// extracted by mini-css-extract-plugin
export default {"tableTabItem":"TableTab_tableTabItem__K-1mg","activeTab":"TableTab_activeTab__wdQ3c"};